export default __webpack_public_path__ + "static/img26h-d677f0b3a57b1fe575751f10e30e1821.jpg";